// src/api/news.service.js
import axios from "axios";

const API_KEY = process.env.REACT_APP_NEWS_API_KEY;
const BASE_URL = "https://gnews.io/api/v4";

export const fetchNewsByCategory = async (category = "general") => {
  try {
    const response = await axios.get(`${BASE_URL}/top-headlines`, {
      params: {
        category,
        lang: "en",
        country: "in",
        max: 50,
        apikey: API_KEY,
      },
    });

    return response.data.articles || [];
  } catch (error) {
    console.error("News API error:", error);
    return [];
  }
};

export const getNewsByCategory = async (category) => {
  const res = await fetch(
    `https://gnews.io/api/v4/top-headlines?topic=${category}&lang=en&country=in&apikey=${API_KEY}`
  );
  const data = await res.json();
  return data.articles || [];
};
